<script>
import { mapActions } from 'vuex';

import Tabs from '@/components/elements/Tabs';
import TableView from '@/components/elements/views/TableView';
import ConfirmationModal from '@/components/elements/ConfirmationModal';

export default {
    components: {
        Tabs,
        ConfirmationModal
    },
    page: {
        title: 'Reports'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Reports',
            reasons: {
                inappropriate: 'Inappropriate',
                bad_file: 'Bad file',
                file_wrong_place: 'File is not in the right place',
                copyrights: 'File breaks copyrights',
                other: 'Other'
            },
            actions: [
                {
                    icon: 'fa fa-check-circle',
                    method: 'toggleReviewed'
                }
            ]
        };
    },

    computed: {
        labels() {
            return [
                { value: 'comment.user.nickname', text: 'Author' },
                { value: 'user.nickname', text: 'Reporter' },
                { value: 'comment.text' },
                { value: 'reason', filter: reason => this.reasons[reason] },
                { value: 'message' },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    value: 'reviewed',
                    type: 'boolean',
                    isBadge: true
                }
            ];
        },

        options() {
            return {
                filters: true,
                addButton: false
            };
        },

        confirmationModalContent() {
            return 'Are you sure you want to delete this comment?';
        }
    },

    methods: {
        ...mapActions({
            getItems: 'reports/index',
            deleteItem: 'reports/destroy',
            updateReport: 'reports/update'
        }),

        async toggleReviewed(id) {
            const index = this.items.findIndex(item => item.id === id);

            const { reviewed } = this.items[index];

            await this.updateReport({ id, data: { reviewed: !reviewed } });

            this.items.splice(index, 1, {
                ...this.items[index],
                reviewed: !reviewed
            });
        }
    }
};
</script>
